/** Visible environment name for the header. Production hosts stay unlabeled. */
export function deploymentLabel(hostname: string, explicitEnv?: string): string | null {
    const env = (explicitEnv || '').trim().toLowerCase();
    if (env === 'production' || env === 'prod') return null;
    if (env === 'staging' || env === 'stage') return 'Staging';
    if (env === 'local' || env === 'development' || env === 'dev') return 'Local';

    const host = (hostname || '').toLowerCase();
    if (host === 'localhost' || host === '127.0.0.1') return 'Local';
    if (host === 'crypto-portal.outris.com' || host.includes('staging')) return 'Staging';
    return null;
}
